module.exports = require("react-router-redux").routerReducer;



// WEBPACK FOOTER //
// ./src/reducers/router.js